import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const UserWrap = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  height: auto;
  padding: 5px;
  border-radius: 30px;
  border: 1px solid rgba(205, 205, 205, 0.2);
  background: var(--white);

  .icon-chevron-down {
    font-size: var(--font-size-xs);
    line-height: 1;
    color: var(--light);
    margin: 2px 6px 0 0;
  }
`;

export const ImgBox = styled.div`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  overflow: hidden;

  img {
    display: block;
    border-radius: 100%;
    object-fit: cover;
    max-width: 100%;
    width: 28px;
    height: 28px;
  }
`;

export const TextBox = styled.div`
  flex-grow: 1;
  padding: 0 10px;
  color: var(--light);
`;

export const Name = styled.strong`
  display: block;
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
  text-transform: capitalize;
  color: var(--light);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 74px;
`;

export const Designation = styled.span`
  display: block;
  font-size: var(--font-size-xs);
  line-height: 15px;
  font-weight: 400;
  color: var(--primary-text-color);
  text-transform: capitalize;
`;

export const DropDown = styled.div`
  /* max-height: 0;
  visibility: hidden;
  opacity: 0; */
  position: absolute;
  top: 100%;
  right: 0;
  width: 250px;
  padding: 20px 15px;
  margin-top: 5px;
  transition: linear 0.3s;
  max-height: ${({ dropdownOpen }) => (dropdownOpen ? '200px' : '0px')};
  visibility: ${({ dropdownOpen }) => (dropdownOpen ? 'visible' : 'hidden')};
  opacity: ${({ dropdownOpen }) => (dropdownOpen ? '1' : '0')};
  z-index: 1;
  background: #25214e;
  box-shadow: -29px 60px 90px rgba(23, 18, 43, 0.55);

  border-radius: 10px;

  .light & {
    background: var(--white);

    &:before {
      background: var(--white);
    }
  }

  &:before {
    content: '';
    position: absolute;
    top: -9px;
    right: 20px;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    border-radius: 3px;
    background: #25214e;
    z-index: -1;
  }

  li {
    &:first-child {
      display: none;
    }
  }
`;

export const ProfileHolder = styled.div`
  flex-shrink: 0;
  width: 150px;
  margin-left: 10px;
  background: var(--dark-blue);
  border-radius: 30px;
  position: relative;
  z-index: 2;

  /* &:hover {
    ${DropDown} {
      max-height: 200px;
      visibility: visible;
      opacity: 1;
    }

    ${UserWrap} {
      .icon {
        transform: scale(-1);
      }
    }
  } */
`;

export const Ul = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const Li = styled.li`
  padding: 2px 0;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  color: #8786ab;
  /* background: var(--bg-primary); */

  .icon-chevron-right {
    font-size: 10px;
    line-height: 1;
  }

  &:hover {
    background: linear-gradient(224.09deg, rgba(26, 23, 62, 0.45) 0%, rgba(18, 16, 48, 0.49) 98.47%);
  }

  .light & {
    &:hover {
      background: #fbfbfd;
    }
  }
`;

export const Text = styled.span`
  flex-grow: 1;
  font-size: var(--font-size-sm);
  line-height: 15px;
  font-weight: 700;
  text-transform: capitalize;
  padding: 0 10px;
`;

export const IconHolder = styled.span`
  font-size: var(--font-size-xs);
  line-height: 1;

  .icon-moon,
  .icon-person,
  .icon-logout {
    font-size: 16px;
    line-height: 1;
  }
`;

export const PlaceHolder = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  height: 100%;
  background: #edfad6;
  color: #9dcb4c;
  border-radius: 100%;
`;
